/* components/ProductsFilters
- Used within collection and search templates

Example
<collection-filters>
    [[collection filters content]]
</collection-filters>
*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { parseUrl, stringifyUrl } from 'query-string';

@Component
export class CollectionFilters extends ThemeComponent {
    @Ref() sortBy!: HTMLSelectElement;
    @Ref() details!: HTMLDListElement[];
    @Ref() toggle!: HTMLButtonElement;
    @Ref() form!: HTMLFormElement;
    init() {
        this.handleDetailsOpen(this.details);

        if (this.sortBy) {
            this.$listen(this.sortBy, 'change', () => {
                this.updateValue();
            });
        }

        if (this.toggle) {
            this.toggle.addEventListener('click', () => this.toggleOpen());
        }
    }

    private toggleOpen() {
        this.form.classList.toggle('is-active');
    }

    private handleDetailsOpen(details: HTMLDListElement[]) {
        for (const detail of details) {
            detail.addEventListener("click", () => {
                for (const sibling of details) {
                    if (detail !== sibling) {
                        sibling.removeAttribute("open");
                    }
                }
            });
        }
    }

    private updateValue() {
        if (this.sortBy) {
            const { url, query } = parseUrl(window.location.href);
            window.location.href = stringifyUrl({
                url,
                query: {
                    ...query,
                    // Follow Shopify's own parameters - can't use camelCasing
                    // eslint-disable-next-line
                    sort_by: this.sortBy.value
                }
            });

        }
    }
}
